import uuid from 'uuid/v1';
import PriorityProcessingImage from './PriorityProcessings.base6';
import Languages from './translations';
import { getIn } from 'immutable';
// import compareVersions from 'compare-versions';

export const BREAK_POINTS = {
    kill_draft: (shopContext) => {
        return shopContext.state.settings.multiCurrencyMode;
        // const installedAt = new Date(shopContext.state.installedAt).getTime();
        // const breakPoint = new Date('Sun Apr 18 2021 15:00:00 GMT+0100').getTime();
        // return installedAt > breakPoint;
    }
};

export const CAMPAIGN_TARGETS = [
    {
        value: 'all_products',
        label: 'All Products',
        disabled: ({ state }, shopContext) => {
            return BREAK_POINTS['kill_draft'](shopContext)
                ? state.settings.type === 'bundles'
                : false;
        }
    },
    { value: 'specific_products', label: 'Specific Products' },
    { value: 'specific_collections', label: 'Specific Collections' }
];
export const ADD_TO_UNLOCK_FREE_SHIPPING_HANDLER = [
    {
        value: false,
        label: 'MonsterUpsells',
        info: 'Shopify will inject a unique Free Shipping coupon code at checkout'
    },
    {
        value: true,
        label: 'Shopify Admin',
        info: 'You need to setup Free Shipping threshold in Shopify Admin',
        link: {
            href: 'https://help.shopify.com/en/manual/shipping/setting-up-and-managing-your-shipping/setting-up-shipping-rates?fbclid=IwAR3OtBxohPJS0X1kzl1sOLfIqyCHkJkiLGiJPwmeAlkK3MAfZN6VdtmQw2s#create-free-shipping-rates',
            text: 'Learn More'
        }
    }
];
export const CAMPAIGN_TYPES = {
    bundles: 'buy more save more',
    add_to_unlock: 'Add to unlock + Frequently bought Together',
    one_check_up_sell: 'one tick upsell'
};

export const ONE_CHECK_UP_SELL_PRODUCT_TYPE_OPTIONS = [
    { value: 'hidden', label: 'Virtual Product' },
    { value: 'existing', label: 'Existing Product' }
];

export const GOOGLE_FONTS = [
    { value: 'Raleway', label: 'Raleway' },
    { value: 'Dosis', label: 'Dosis' }
];

export const RESOURCE_PICKER_DEFAULT_REDUCERS = {
    Product: ({ id, title, variants, images, handle }) => ({
        id,
        title,
        handle,
        image: images.length ? images[0].originalSrc : null,
        price: variants[0].price
    }),
    Collection: ({ id, title, image, handle }) => ({
        id,
        title,
        handle,
        image: image && image.originalSrc ? image.originalSrc : null
    })
};

export const ADD_TO_UNLOCK_PRODUCTS_PICKER_REDUCER = ({
    id,
    title,
    variants,
    options,
    images,
    handle
}) => ({
    id,
    title,
    handle,
    image: images.length ? images[0].originalSrc : null,
    variants: variants.map(ADD_TO_UNLOCK_PRODUCTS_VARIANTS_MAP),
    options
});

export const ONE_CHECK_UP_SELL_PRODUCT_REDUCER = ({
    id,
    title,
    variants,
    options,
    images,
    image,
    handle,
    body_html
}) => ({
    id: id.toString(),
    title: title.toString(),
    handle,
    image: image ? image.originalSrc : images.length ? images[0].src || images[0].originalSrc : '',
    variant_id: variants[0].id.toString(),
    options,
    variants: variants.map(ADD_TO_UNLOCK_PRODUCTS_VARIANTS_MAP)
});

export const GIFT_WITH_PURCHASE_PRODUCT_REDUCER = (product) => {
    const { id, title, variants, options, images, image, handle, body_html } = product;
    const variant = variants[0];
    if (!variant) throw new Error('variant not found');
    const price = Number(variant.price) * 100;
    const compareAtPrice = variant.compareAtPrice ? Number(variant.compareAtPrice) * 100 : price;
    const productImage = image
        ? image.originalSrc
        : images.length
        ? images[0].src || images[0].originalSrc
        : '';
    return {
        id: id.toString(),
        title: title.toString(),
        handle,
        image: image
            ? image.originalSrc
            : images.length
            ? images[0].src || images[0].originalSrc
            : '',
        variant_id: variants[0].id.toString(),
        variants: variants.map(ADD_TO_UNLOCK_PRODUCTS_VARIANTS_MAP),
        options,
        variant_price: compareAtPrice
    };
};

const ADD_TO_UNLOCK_PRODUCTS_VARIANTS_MAP = ({
    id,
    title,
    price,
    image,
    productImage = null,
    option1,
    option2,
    option3,
    compareAtPrice
}) => ({
    id: id.toString(),
    title,
    price,
    compare_at_price: compareAtPrice ? Number(compareAtPrice) * 100 : undefined,
    option1,
    option2,
    option3,
    image: image ? image.originalSrc : productImage
});

export const DISCOUNT_TYPES = (currency = '$ ') => [
    { label: '% ', value: 'percentage' },
    { label: `${currency} `, value: 'fixed_amount' }
];

export const GET_GOAL_TYPES = (currency = '$ ') => {
    return [
        { label: '% ', value: 'relative' },
        { label: `${currency} `, value: 'fixed' }
    ];
};

export const ADD_TO_UNLOCK_REWARD_OPTIONS = (goals, index) => {
    const otherGoals = goals.filter((_, i) => i !== index).map(({ reward_type }) => reward_type);
    return [
        {
            value: 'discount',
            label: 'Discount',
            info: 'Unlock discounts that will be auto aded to the checkout using discount codes'
        },
        {
            value: 'free_shipping',
            label: 'Free Shipping',
            info: 'You need to setup free shipping options in Shopify Admin',
            disabled: otherGoals.includes('free_shipping')
        },
        {
            value: 'gift',
            label: 'Free Gift',
            info: 'Select a product as a free gift when cart goals are met',
            disabled: !goals[index].gift
            // beta: true
        },
        {
            value: 'manual',
            label: 'Manual / Store Credit (CashBack)',
            infoHtml: true,
            info: 'Create a goal that you will reward yourself.<br/><b>Example:</b> Free products, Gift wrapping, Free express shipping'
        }
    ];
};

export const CART_SLIDER_SETTINGS = {
    dots: false,
    arrows: false,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    adaptiveHeight: false,
    draggable: false,
    infinite: false,
    easing: 'easeOut'
};

const default_background = { r: 255, g: 255, b: 255, a: 1 };
const default_primary = { a: 1, b: 248, g: 117, r: 90 };
const default_secondary = { a: 1, b: 255, g: 222, r: 215 };
const default_font_color = { r: 22, g: 37, b: 67, a: 1 };
const default_danger = { r: 239, g: 68, b: 68, a: 1 };

export const NEW_CAMPAIGN_INITIAL_STATE = (
    {
        checkout_button = {
            background: default_primary,
            hoverBackground: default_secondary
        },
        primary = default_primary,
        secondary = default_secondary,
        font_color = default_font_color,
        background = default_background,
        danger = default_danger,
        type = '',
        multiCurrencyMode
    } = {},
    language,
    currency
) => {
    language = Object.keys(Languages).includes(language) ? language : 'english';
    const __ = translate(language);
    return {
        name: '',
        settings: {
            type,
            applied_discount_title: 'Special Discount',
            bundles: {
                text: __('campaigns.bundles.text'),
                prefix: __('campaigns.bundles.prefix'),
                font_size: 0.8,
                background: secondary,
                color: font_color,
                activeBackground: primary,
                activeColor: background,
                list: [
                    { id: uuid(), type: 'percentage', quantity: 2, reward: 10 },
                    { id: uuid(), type: 'percentage', quantity: 3, reward: 15 }
                ],
                style: 'vertical',
                labelColor: primary,
                badge: {
                    text: { a: 1, r: 0, g: 45, b: 255 },
                    background: { a: 1, r: 240, g: 242, b: 255 },
                    border: { a: 1, r: 161, g: 178, b: 255 }
                },
                variantsPicker: {
                    active: true,
                    label: 'Select product #{{number}}',
                    confirm: 'Confirm',
                    textColor: default_font_color,
                    dropdownTextColor: default_font_color,
                    dropdownBackground: secondary,
                    confirmTextColor: background,
                    confirmBackground: primary
                }
            },
            add_to_unlock: {
                isActive: true,
                show_all_locked_goals: false,
                title: {
                    text: __('campaigns.add_to_unlock.title.text'),
                    font_size: 1,
                    color: font_color
                },
                background: secondary,
                borderColor: secondary,
                show_product_details: {
                    text: __('campaigns.add_to_unlock.show_product_details.text'),
                    font_size: 0.7,
                    color: primary
                },
                product_title: {
                    text: '{{product_title}}',
                    font_size: 1,
                    color: font_color
                },
                product_price: {
                    text: '{{original_price}}{{product_price}}',
                    font_size: 0.9,
                    color: font_color
                },
                upsell_add_button: {
                    text: __('campaigns.add_to_unlock.upsell_add_button.text'),
                    color: primary,
                    font_size: 0.8
                },
                upsell_confirm_button: {
                    text: __('campaigns.add_to_unlock.upsell_confirm_button.text'),
                    font_size: 0.8
                },
                show_suggestions: true,
                recommendation_type: 'shopify_recommendation',
                products_length: 2,
                exclude_tags: [],
                products: [],
                separator: {
                    active: false,
                    text: __('campaigns.add_to_unlock.separator.text')
                },
                multi_goal_type: 'amount',
                show_badges: false,
                goals: [
                    {
                        badge: {
                            show_text: true,
                            text: { text: '{{goal}}', font_size: 1, color: default_primary },
                            type: 2,
                            image: null
                        },
                        specific_goals: [{ currency, goal: 40, main: true }],
                        reward_type: 'free_shipping',
                        goal_type: 'fixed',
                        goal_text: {
                            text: 'Free Shipping',
                            font_size: 0.7,
                            color: { r: 44, g: 50, b: 59, a: 1 }
                        },
                        show_goal_text: false,
                        confetti: false,
                        confetti_length: 400,
                        discount: {
                            type: 'percentage',
                            before: __('campaigns.add_to_unlock.discount.before'),
                            after: __('campaigns.add_to_unlock.discount.after'),
                            reward: 10
                        },
                        free_shipping: {
                            before: __('campaigns.add_to_unlock.free_shipping.before'),
                            after: __('campaigns.add_to_unlock.free_shipping.after'),
                            manual: true
                        },
                        manual: {
                            before: __('campaigns.add_to_unlock.free_shipping.before'),
                            after: __('campaigns.add_to_unlock.free_shipping.after')
                        },
                        gift: {
                            before: __('campaigns.add_to_unlock.gift.before'),
                            after: __('campaigns.add_to_unlock.gift.after'),
                            products: [],
                            previous_gift: 'keep',
                            multi_gift_select: 'select',
                            widget: {
                                active: true,
                                compare_at_price_active: true,
                                compare_at_price: {
                                    color: { r: 141, g: 141, b: 141, a: 1 },
                                    font_size: 1,
                                    text: __('campaigns.add_to_unlock.gift.compare_at_price.text')
                                },
                                before: {
                                    header: __('campaigns.add_to_unlock.gift.widget.before.header'),
                                    product_name: __(
                                        'campaigns.add_to_unlock.gift.widget.before.product_name'
                                    ),
                                    offer_highlight: {
                                        color: { r: 95, g: 95, b: 95, a: 1 },
                                        font_size: 1.2,
                                        text: __(
                                            'campaigns.add_to_unlock.gift.widget.before.offer_highlight.text'
                                        )
                                    }, //   color: background, // goal: 40, // or custom_recommendation shopify_recommendation //  quantity // product: {}, // free_shipping,discount, manual, gift // variant_selector_text: {
                                    //   font_size: 1,
                                    //   text: __("campaigns.add_to_unlock.gift.widget.before.variant_selector_text.text")
                                    // },
                                    background: { r: 242, g: 245, b: 255, a: 1 },
                                    outline: { r: 196, g: 196, b: 196, a: 1 },
                                    multi_gift_image:
                                        'https://d1s1zm0vzu692k.cloudfront.net/static/images/default_gifts.png'
                                },
                                selecting: {
                                    header: __(
                                        'campaigns.add_to_unlock.gift.widget.selecting.header'
                                    ),
                                    product_name: __(
                                        'campaigns.add_to_unlock.gift.widget.selecting.product_name'
                                    ),
                                    offer_highlight: {
                                        color: { r: 95, g: 95, b: 95, a: 1 },
                                        font_size: 1.2,
                                        text: __(
                                            'campaigns.add_to_unlock.gift.widget.selecting.offer_highlight.text'
                                        )
                                    },
                                    variant_selector_text: {
                                        color: background,
                                        font_size: 1,
                                        text: __(
                                            'campaigns.add_to_unlock.gift.widget.selecting.variant_selector_text.text'
                                        )
                                    },
                                    background: { r: 242, g: 245, b: 255, a: 1 },
                                    outline: { r: 196, g: 196, b: 196, a: 1 },
                                    variant_button_background: primary
                                },
                                after: {
                                    header: __('campaigns.add_to_unlock.gift.widget.after.header'),
                                    product_name: __(
                                        'campaigns.add_to_unlock.gift.widget.after.product_name'
                                    ),
                                    offer_highlight: {
                                        color: { r: 79, g: 181, b: 110, a: 1 },
                                        font_size: 1.2,
                                        text: __(
                                            'campaigns.add_to_unlock.gift.widget.after.offer_highlight.text'
                                        )
                                    },
                                    background: { r: 248, g: 251, b: 246, a: 1 },
                                    outline: { r: 203, g: 235, b: 206, a: 1 },
                                    variant_change_text: {
                                        color: { r: 134, g: 134, b: 134, a: 1 },
                                        font_size: 1,
                                        text: __(
                                            'campaigns.add_to_unlock.gift.widget.after.variant_change_text.text'
                                        )
                                    }
                                }
                            }
                        }
                    }
                ],
                separator: {
                    active: false,
                    text: __('campaigns.add_to_unlock.separator.text')
                },
                progress_primary: primary,
                progress_secondary: secondary,
                progress_complete: { a: 1, r: 87, g: 239, b: 197 },
                progress_background: { a: 1, r: 255, g: 255, b: 255 },
                product_details: {
                    atcButton: {
                        color: { a: 1, b: 255, g: 255, r: 255 },
                        font_size: 1,
                        text: __('product_details.atcButton.text')
                    },
                    atcButton_background: { a: 1, b: 248, g: 117, r: 90 },
                    atcButton_hoverBackground: { a: 1, b: 206, g: 206, r: 206 },
                    external: false,
                    readMore: {
                        color: { a: 1, b: 248, g: 117, r: 90 },
                        font_size: 1,
                        text: __('product_details.readMore.text')
                    },
                    truncate: true,
                    truncate_length: 200
                },
                fbt_below: true,
                fbt_position: 'above_checkout'
            }, // inventory_quantity: { // variant_button_background: primary, // one_check_up_sell: default_one_check_upsell(language),
            //   active: true,
            //   text: __("campaigns.add_to_unlock.gift.inventory_quantity.text")
            // }
            multi_one_check_upsell: {
                variant: 'square',
                align: 'natural',
                border: false,
                border_color: { r: 226, g: 232, b: 240, a: 1 },
                switch_on: primary,
                switch_off: secondary,
                highlight: primary,
                products: [default_one_check_upsell(language)]
            },
            modules: {
                order: ['checkout_button', 'random_text', 'order_note'],
                random_text: { text: __('modules.random_text.text'), active: false },
                order_note: { text: __('modules.order_note.text'), active: false },
                checkout_button: {
                    checkout_as_link: false,
                    show_subtotal: true,
                    fix_checkout_container: true,
                    active_continue_shopping_button: false,
                    active_continue_shopping_underlined: true,
                    continue_shopping_button: {
                        text: 'Continue shopping',
                        font_size: 1,
                        color: primary
                    },
                    button_text: {
                        text: __('modules.checkout_button.button_text.text'),
                        font_size: 1.3,
                        color: background
                    },
                    button_text_loading: {
                        text: __('modules.checkout_button.button_text_loading.text'),
                        color: background
                    },
                    background: checkout_button.background,
                    hoverBackground: checkout_button.hoverBackground,
                    coupon: {
                        background: checkout_button.background,
                        hoverBackground: checkout_button.hoverBackground,
                        active_background: checkout_button.background,
                        active_color: secondary
                    },
                    coupon_alert_text: {
                        text: __('modules.checkout_button.coupon_alert_text.text'),
                        font_size: 1,
                        color: danger
                    },
                    use_coupon_code: {
                        text: __('modules.checkout_button.use_coupon_code.text'),
                        font_size: 0.9,
                        color: { r: 160, g: 160, b: 160, a: 1 }
                    },
                    enter_coupon_code: {
                        text: __('modules.checkout_button.enter_coupon_code.text'),
                        font_size: 0.9,
                        color: secondary
                    },
                    apply_coupon_code: {
                        text: __('modules.checkout_button.apply_coupon_code.text'),
                        font_size: 1,
                        color: background
                    },
                    edit_coupon_code: {
                        text: __('modules.checkout_button.edit_coupon_code.text'),
                        font_size: 0.9
                    },
                    close_coupon_code: {
                        text: __('modules.checkout_button.close_coupon_code.text'),
                        font_size: 0.9
                    },
                    subtotal: {
                        text: __('modules.checkout_button.subtotal.text'),
                        font_size: 1.3,
                        color: font_color
                    },
                    savings: {
                        text: __('modules.checkout_button.savings.text'),
                        font_size: 1.3,
                        color: checkout_button.background
                    }
                }
            }
        },
        target: {
            type: 'all_products',
            selected: [],
            countries: {
                include_active: false,
                include: ['worldwide'],
                exclude_active: false,
                exclude: []
            }
        }
    };
};

function translate(language) {
    return (path) => {
        path = path.split('.');
        return getIn(Languages[language], path) || getIn(Languages.english, path);
    };
}

export const default_one_check_upsell = (language) => {
    const __ = translate(language);
    return {
        text: __('campaigns.one_check_up_sell.text'),
        is_ticked_by_default: false,
        include_in_atu: true,
        product: {},
        product_type: 'existing',
        truncate: true,
        truncate_length: 25
    };
};

export const SHOP_DEFAULT_SETTINGS = (language) => {
    language = Object.keys(Languages).includes(language) ? language : 'english';
    const __ = translate(language);
    return {
        modules: NEW_CAMPAIGN_INITIAL_STATE({}, language).settings.modules,
        active: false,
        open_cart: true,
        multiCurrencyMode: true,
        rtl: __('rtl'),
        curved: true,
        show_coupon: false,
        show_coupon_alert_text: true,
        is_checkout_condition_active: false,
        checkout_condition_color: default_primary,
        checkout_condition_text: 'I agree to <b>Terms & conditions</b>',
        active_continue_shopping_button: true,
        active_continue_shopping_underlined: true,
        count_compare_at: true,
        continue_shopping_button: {
            text: 'Continue shopping',
            font_size: 1,
            font_weight: 700,
            color: default_primary
        },
        empty_cart:
            '<p class="ql-align-center"><img src="https://cdn.shopify.com/s/files/1/0597/9367/0293/t/38/assets/download.png?v=1667818689"></p>',
        font: {
            color: {
                a: 1,
                b: 67,
                g: 37,
                r: 22
            },
            custom: false,
            family: 'Poppins:100,100italic,200,200italic,300,300italic,regular,italic,500,500italic,600,600italic,700,700italic,800,800italic,900,900italic',
            size: 14
        },
        header: {
            background: {
                a: 1,
                b: 255,
                g: 255,
                r: 255
            },
            title: {
                color: {
                    a: 1,
                    b: 0,
                    g: 0,
                    r: 0
                },
                font_size: 1.1,
                text: __('header.title')
            }
        },
        product: {
            sold_out: __('product.sold_out'),
            grow: false,
            image_size: 80,
            price: {
                color: {
                    a: 1,
                    b: 67,
                    g: 37,
                    r: 22
                },
                font_size: 1.1,
                text: '{{original_price}}{{product_price}}'
            },
            title: {
                color: {
                    a: 1,
                    b: 67,
                    g: 37,
                    r: 22
                },
                font_size: 1.1,
                text: '{{product_title}}'
            },
            show_bin: true,
            allow_variants_editing: false,
            editable_quantity: false,
            bin_color: {
                a: 1,
                b: 119,
                g: 119,
                r: 119
            },
            variants: {
                color: {
                    a: 1,
                    b: 119,
                    g: 119,
                    r: 119
                },
                font_size: 0.9,
                font_weight: 500
            }
        },
        product_details: {
            atcButton: {
                color: {
                    a: 1,
                    b: 255,
                    g: 255,
                    r: 255
                },
                font_size: 1,
                text: __('product_details.atcButton.text')
            },
            atcButton_background: {
                a: 1,
                b: 178,
                g: 84,
                r: 64
            },
            atcButton_hoverBackground: {
                a: 1,
                b: 206,
                g: 206,
                r: 206
            },
            external: false,
            readMore: {
                color: {
                    a: 1,
                    b: 178,
                    g: 84,
                    r: 64
                },
                font_size: 1,
                text: __('product_details.readMore.text')
            },
            truncate: true,
            truncate_length: 200
        },
        theme: {
            background: {
                a: 1,
                b: 255,
                g: 255,
                r: 255
            },
            primary: {
                a: 1,
                b: 248,
                g: 117,
                r: 90
            },
            secondary: {
                a: 1,
                b: 255,
                g: 222,
                r: 215
            },
            textColor: {
                a: 0.8,
                b: 67,
                g: 37,
                r: 22
            },
            buttonColor: {
                a: 1,
                b: 255,
                g: 255,
                r: 255
            }
        },
        default_language: language,

        cod_settings: {
            error_message: 'This field is required',
            is_active: false,
            is_form_in_cart: false,
            checkout_mode: 'cod_and_checkout', // cod_and_checkout cod_only
            checkout_button: {
                text: 'PAY ON DELIVERY',
                font_size: 1.7,
                color: default_background,
                background: default_primary,
                hoverBackground: default_secondary
            },
            confirm_button: {
                text: 'Confirm Order',
                font_size: 1.7,
                color: default_background,
                background: default_primary,
                hoverBackground: default_secondary
            },
            loading_button: {
                text: 'Loading ...',
                font_size: 1.7,
                color: default_background,
                background: default_primary,
                hoverBackground: default_secondary
            },
            form: [
                {
                    label: 'First name', // editable
                    isRequired: true, // obligatry for customer
                    type: 'name',
                    placeholder: 'Please enter your full name'
                },
                {
                    label: 'Email',
                    isRequired: false,
                    type: 'email',
                    placeholder: 'Please enter your email'
                },
                // {
                // 	label: "Zip Code",
                // 	isRequired: true
                // },
                {
                    label: 'Phone number',
                    isRequired: true,
                    type: 'phone',
                    placeholder: 'Please enter your phone number'
                },
                {
                    label: 'Address',
                    isRequired: true,
                    type: 'string',
                    placeholder: 'Please enter your address'
                },
                {
                    label: 'Note to seller',
                    isRequired: false,
                    type: 'textarea',
                    placeholder: 'Please enter your a custome note'
                }
            ]
        },
        sticky_cart: {
            isActive: false,
            btn_style: 'square',
            btn_text: 'Add To Cart',
            btn_text_variant_active: 'CONFIRM',
            btn_text_unavailable: 'UNAVAILABLE',
            btn_color: default_primary,
            txt_color: {
                r: 255,
                g: 255,
                b: 255,
                a: 1
            },
            background_color: {
                r: 255,
                g: 255,
                b: 255,
                a: 1
            },

            atc_action: 'checkout',

            desktop_active: true,
            desktop_show_variants: true,
            desktop_show_quantity: true,
            desktop_show_product_name: true,
            desktop_product_preview: true,
            desktop_show_compared_price: true,

            desktop_visibility: 'dynamic',
            desktop_location: 'bottom',

            desktop_quantity: {
                text: 'Quantity'
                // font_size: 1.7,
            },
            mobile_quantity: {
                text: 'Quantity'
                // font_size: 1.7,
            },
            cart_name: {
                text: 'Add To Cart'
                // font_size: 1.7,
            },
            mobile_active: true,
            mobile_show_variants: true,
            mobile_show_quantity: true,
            mobile_show_compared_price: true,

            mobile_show_title: true,
            mobile_show_price: true,

            mobile_visibility: 'dynamic',
            mobile_location: 'bottom',
            mobile_atc_height: {
                text: 50
            },

            show_btn_atc_txt_variant_active: false,
            btn_atc_txt_variant_active: 'Choose size'
        },
        auto_discount: {
            text: {
                color: {
                    a: 1,
                    r: 0,
                    g: 45,
                    b: 255
                },
                font_weight: 400,
                font_size: 0.9,
                text: '{{title}}'
            },
            background: {
                a: 1,
                r: 240,
                g: 242,
                b: 255
            },
            border: {
                a: 1,
                r: 161,
                g: 178,
                b: 255
            }
        },
        subscription: {
            isActive: false,
            text: {
                color: {
                    a: 1,
                    r: 255,
                    g: 255,
                    b: 255
                },
                font_weight: 700,
                font_size: 0.9,
                text: 'Upgrade to {{plans_group_name}}'
            },
            background: {
                a: 1,
                r: 26,
                g: 68,
                b: 156
            },
            border: {
                a: 1,
                r: 26,
                g: 68,
                b: 156
            },
            upgradingText: {
                color: {
                    a: 1,
                    r: 255,
                    g: 255,
                    b: 255
                },
                font_weight: 700,
                font_size: 0.9,
                text: 'Upgrading...'
            },
            downgradingText: {
                color: {
                    a: 1,
                    r: 255,
                    g: 255,
                    b: 255
                },
                font_weight: 700,
                font_size: 0.9,
                text: 'Downgrading...'
            },
            loadingBackground: {
                a: 1,
                r: 153,
                g: 153,
                b: 153
            },
            loadingBorder: {
                a: 1,
                r: 153,
                g: 153,
                b: 153
            },
            subscribedText: {
                color: {
                    a: 1,
                    r: 0,
                    g: 0,
                    b: 0
                },
                font_weight: 500,
                font_size: 0.9,
                text: '{{selling_plan_name}}'
            },
            subscribedBackground: {
                a: 1,
                r: 255,
                g: 255,
                b: 255
            },
            subscribedBorder: {
                a: 1,
                r: 153,
                g: 153,
                b: 153
            }
        },
        scary: {
            isActive: false,
            text: {
                color: {
                    a: 1,
                    r: 0,
                    g: 45,
                    b: 255
                },
                font_size: 0.7,
                text: '🔥 Your cart is reserved for... {{timer}} minutes'
            },
            style: 'rounded',
            background: {
                a: 1,
                r: 240,
                g: 242,
                b: 255
            },
            border: {
                a: 1,
                r: 161,
                g: 178,
                b: 255
            },
            isDaysActive: false,
            isHoursActive: true,
            isMinutesActive: true,
            isSecondsActive: true,
            days: 0,
            hours: 0,
            minutes: 4,
            seconds: 49,
            endAction: 'hide', // hide restart
            placement: 'bottom', // bottom top
            textAlignement: 'left' // left center right
        },
        badges: {
            isActive: false,
            position: 'bellow_checkout', // BADGES_POSITIONS
            value: '<p class="ql-align-center" style="color: #162543;font-size: 13px;">Guaranteed Safe &amp; Secure Checkout </p><p><img src="https://storage.crisp.chat/users/upload/operator/efc812c3c6152000/payment-methods-min_dp91kr.png"></p>'
        },
        afterPay: {
            isActive: false,
            splits: 4,
            text: {
                color: {
                    a: 1,
                    r: 22,
                    g: 37,
                    b: 67
                },
                font_size: 0.8,
                font_weight: 700,
                text: 'Or {{installments}} installments of {{split payment}} with'
            },
            image: 'https://s3-us-west-2.amazonaws.com/apps.static.resources/afterpay_black.png',
            isExternal: false
        },
        announcement: {
            isActive: false,
            position: 'bellow_products', //ANNOUNCEMENT_POSITIONS
            text: {
                color: {
                    a: 1,
                    r: 0,
                    g: 102,
                    b: 79
                },
                font_size: 0.7,
                text: '⏰ Order before your items are out of stock!'
            },
            style: 'rounded', // full
            background: {
                a: 0.22,
                r: 80,
                g: 277,
                b: 194
            },
            border: {
                a: 1,
                r: 80,
                g: 277,
                b: 194
            },
            textAlignement: 'center' // left center right
        }
    };
};
export const BADGE_PERCENT_ICON = {
    //this icon is missing on fontawesome package
    prefix: 'fas',
    iconName: 'adjust',
    icon: [
        512,
        512,
        [],
        'f646',
        'M512 256c0-37.7-23.7-69.9-57.1-82.4 14.7-32.4 8.8-71.9-17.9-98.6-26.7-26.7-66.2-32.6-98.6-17.9C325.9 23.7 293.7 0 256 0s-69.9 23.7-82.4 57.1c-32.4-14.7-72-8.8-98.6 17.9-26.7 26.7-32.6 66.2-17.9 98.6C23.7 186.1 0 218.3 0 256s23.7 69.9 57.1 82.4c-14.7 32.4-8.8 72 17.9 98.6 26.6 26.6 66.1 32.7 98.6 17.9 12.5 33.3 44.7 57.1 82.4 57.1s69.9-23.7 82.4-57.1c32.6 14.8 72 8.7 98.6-17.9 26.7-26.7 32.6-66.2 17.9-98.6 33.4-12.5 57.1-44.7 57.1-82.4zm-320-96c17.67 0 32 14.33 32 32s-14.33 32-32 32-32-14.33-32-32 14.33-32 32-32zm12.28 181.65c-6.25 6.25-16.38 6.25-22.63 0l-11.31-11.31c-6.25-6.25-6.25-16.38 0-22.63l137.37-137.37c6.25-6.25 16.38-6.25 22.63 0l11.31 11.31c6.25 6.25 6.25 16.38 0 22.63L204.28 341.65zM320 352c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32z'
    ]
};

const parseProductId = (string) => {
    // example gid://shopify/ProductVariant/19566771404862
    const pattern = new RegExp('gid://shopify/Product/([0-9]+)$');
    if (pattern.test(string)) return parseInt(string.match(pattern)[1]);
    return string;
};

export const stateCards = [
    { title: 'CartsDisplayed' },
    { title: 'SalesGenerated', label: 'Cart Orders' },
    { title: 'SalesAmount', label: 'Cart Total Revenue', currency: true },
    { title: 'AverageOrderSize', currency: true },
    { title: 'CartConversionRate', suf: '%' },
    { title: 'UpsellsGenerated', label: 'Campaign Added Products' },
    { title: 'UpsellsTotalAmount', label: 'Campaign Revenue', currency: true },
    { title: 'TotalROI', suf: '%', clickable: false }
];

export const chartOptions = (formatter) => ({
    fill: {
        type: 'solid',
        color: '#485aff',
        opacity: 0.15
    },
    width: '50%',
    stroke: {
        show: true,
        curve: 'smooth',
        lineCap: 'butt',
        colors: ['#2F80ED'],
        width: 4,
        dashArray: 0
    },
    dropShadow: {
        enabled: true,
        top: 1,
        left: 1,
        blur: 2,
        color: '#000',
        opacity: 0.9
    },
    xaxis: {
        type: 'datetime'
    },
    yaxis: {
        type: 'numeric'
    },
    dataLabels: {
        enabled: false,
        enabledOnSeries: undefined,
        formatter
    }
});

export const ENGINE_WARNING_ICON = {
    prefix: 'fas',
    iconName: 'engine-warning',
    icon: [
        640,
        448,
        [],
        'f5f2',
        'M48 256c0-59.53 19.55-117.38 55.36-164.51 5.18-6.81 4.48-16.31-2.03-21.86l-12.2-10.41c-6.91-5.9-17.62-5.06-23.15 2.15C23.32 117.02 0 185.5 0 256c0 70.47 23.32 138.96 65.96 194.62 5.53 7.21 16.23 8.05 23.15 2.16l12.19-10.4c6.51-5.55 7.21-15.04 2.04-21.86C67.55 373.37 48 315.53 48 256zM320 32C196.3 32 96 132.3 96 256c0 123.76 100.3 224 224 224s224-100.24 224-224c0-123.7-100.3-224-224-224zm0 352c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm25.44-110.41c-.82 8.18-7.7 14.41-15.92 14.41h-19.04c-8.22 0-15.1-6.23-15.92-14.41l-12.8-128c-.94-9.42 6.45-17.59 15.92-17.59h44.64c9.47 0 16.86 8.17 15.92 17.59l-12.8 128zM572.73 59.71c-5.58-7.18-16.29-7.95-23.17-2l-12.15 10.51c-6.47 5.6-7.1 15.09-1.88 21.87C572.04 137.47 592 195.81 592 256c0 60.23-19.96 118.57-56.46 165.95-5.22 6.78-4.59 16.27 1.88 21.87l12.15 10.5c6.87 5.95 17.59 5.18 23.17-2C616.21 396.38 640 327.31 640 256c0-71.27-23.79-140.34-67.27-196.29z'
    ]
};
export const SACK_DOLLAR_ICON = {
    prefix: 'fas',
    iconName: 'sack-dollar',
    icon: [
        512,
        512,
        [],
        'f81d',
        'M192 96h128l47.4-71.12A16 16 0 0 0 354.09 0H157.94a16 16 0 0 0-13.31 24.88zm128 32H192C-10.38 243.4.09 396.64.09 416c0 53 49.11 96 109.68 96h292.48c60.58 0 109.68-43 109.68-96 0-19 9.35-173.24-191.93-288zm-46.58 278v17.34a8.68 8.68 0 0 1-8.7 8.62h-17.41a8.69 8.69 0 0 1-8.71-8.62v-17.51a63.14 63.14 0 0 1-34.16-12.17 8.52 8.52 0 0 1-.67-13l12.84-12.06a8.93 8.93 0 0 1 11-.76 26.71 26.71 0 0 0 13.93 4h30.58c7.07 0 12.84-6.35 12.84-14.22 0-6.46-3.92-12.06-9.58-13.67l-49-14.54c-20.24-6-34.39-25.2-34.39-46.74 0-26.38 20.68-47.82 46.46-48.57v-17.48a8.69 8.69 0 0 1 8.75-8.62h17.41a8.68 8.68 0 0 1 8.7 8.62v17.55a63.15 63.15 0 0 1 34.17 12.17 8.54 8.54 0 0 1 1.58 12 8.72 8.72 0 0 1-.92 1l-12.73 12.2a8.91 8.91 0 0 1-11 .75 26.8 26.8 0 0 0-13.93-4h-30.57c-7.07 0-12.84 6.35-12.84 14.21 0 6.46 3.92 12.06 9.57 13.68l49 14.54c20.24 6 34.38 25.2 34.38 46.74-.14 26.4-20.92 47.94-46.6 48.54z'
    ]
};

export const COMMENT_DOLLAR = {
    prefix: 'fas',
    iconName: 'comment-dollar',
    icon: [
        512,
        512,
        [],
        'f81d',
        'M256 32C114.62 32 0 125.12 0 240c0 49.56 21.41 95.01 57.02 130.74C44.46 421.05 2.7 465.97 2.2 466.5A7.995 7.995 0 0 0 8 480c66.26 0 115.99-31.75 140.6-51.38C181.29 440.93 217.59 448 256 448c141.38 0 256-93.12 256-208S397.38 32 256 32zm24 302.44V352c0 8.84-7.16 16-16 16h-16c-8.84 0-16-7.16-16-16v-17.73c-11.42-1.35-22.28-5.19-31.78-11.46-6.22-4.11-6.82-13.11-1.55-18.38l17.52-17.52c3.74-3.74 9.31-4.24 14.11-2.03 3.18 1.46 6.66 2.22 10.26 2.22h32.78c4.66 0 8.44-3.78 8.44-8.42 0-3.75-2.52-7.08-6.12-8.11l-50.07-14.3c-22.25-6.35-40.01-24.71-42.91-47.67-4.05-32.07 19.03-59.43 49.32-63.05V128c0-8.84 7.16-16 16-16h16c8.84 0 16 7.16 16 16v17.73c11.42 1.35 22.28 5.19 31.78 11.46 6.22 4.11 6.82 13.11 1.55 18.38l-17.52 17.52c-3.74 3.74-9.31 4.24-14.11 2.03a24.516 24.516 0 0 0-10.26-2.22h-32.78c-4.66 0-8.44 3.78-8.44 8.42 0 3.75 2.52 7.08 6.12 8.11l50.07 14.3c22.25 6.36 40.01 24.71 42.91 47.67 4.05 32.06-19.03 59.42-49.32 63.04z'
    ]
};
export const BOX_CHECK_ICON = {
    prefix: 'fas',
    iconName: 'box-check',
    icon: [
        640,
        512,
        [],
        'f467',
        'M240 0H98.6c-20.7 0-39 13.2-45.5 32.8L2.5 184.6c-.8 2.4-.8 4.9-1.2 7.4H240V0zm235.2 81.7l-16.3-48.8C452.4 13.2 434.1 0 413.4 0H272v157.4C315.9 109.9 378.4 80 448 80c9.2 0 18.3.6 27.2 1.7zM208 320c0-34.1 7.3-66.6 20.2-96H0v240c0 26.5 21.5 48 48 48h256.6C246.1 468.2 208 398.6 208 320zm240-192c-106 0-192 86-192 192s86 192 192 192 192-86 192-192-86-192-192-192zm114.1 147.8l-131 130c-4.3 4.3-11.3 4.3-15.6-.1l-75.7-76.3c-4.3-4.3-4.2-11.3.1-15.6l26-25.8c4.3-4.3 11.3-4.2 15.6.1l42.1 42.5 97.2-96.4c4.3-4.3 11.3-4.2 15.6.1l25.8 26c4.2 4.3 4.2 11.3-.1 15.5z'
    ]
};
export const PERCENTAGE_ICON = {
    prefix: 'fas',
    iconName: 'percentage',
    icon: [
        384,
        512,
        [],
        'f541',
        'M109.25 173.25c24.99-24.99 24.99-65.52 0-90.51-24.99-24.99-65.52-24.99-90.51 0-24.99 24.99-24.99 65.52 0 90.51 25 25 65.52 25 90.51 0zm256 165.49c-24.99-24.99-65.52-24.99-90.51 0-24.99 24.99-24.99 65.52 0 90.51 24.99 24.99 65.52 24.99 90.51 0 25-24.99 25-65.51 0-90.51zm-1.94-231.43l-22.62-22.62c-12.5-12.5-32.76-12.5-45.25 0L20.69 359.44c-12.5 12.5-12.5 32.76 0 45.25l22.62 22.62c12.5 12.5 32.76 12.5 45.25 0l274.75-274.75c12.5-12.49 12.5-32.75 0-45.25z'
    ]
};

export const COMMENT_ALT_SMILE_ICON = {
    prefix: 'fas',
    iconName: 'comment-alt-smile',
    icon: [
        512,
        512,
        [],
        'f4aa',
        'M448 0H64C28.7 0 0 28.7 0 64v288c0 35.3 28.7 64 64 64h96v84c0 9.8 11.2 15.5 19.1 9.7L304 416h144c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64zM320 133.2c14.8 0 26.8 12 26.8 26.8s-12 26.8-26.8 26.8-26.8-12-26.8-26.8 12-26.8 26.8-26.8zm-128 0c14.8 0 26.8 12 26.8 26.8s-12 26.8-26.8 26.8-26.8-12-26.8-26.8 12-26.8 26.8-26.8zm164.2 140.9C331.3 303.3 294.8 320 256 320c-38.8 0-75.3-16.7-100.2-45.9-5.8-6.7-5-16.8 1.8-22.5 6.7-5.7 16.8-5 22.5 1.8 18.8 22 46.5 34.6 75.8 34.6 29.4 0 57-12.6 75.8-34.7 5.8-6.7 15.9-7.5 22.6-1.8 6.8 5.8 7.6 15.9 1.9 22.6z'
    ]
};

export const USER_SHIELD_ICON = {
    prefix: 'fas',
    iconName: 'user-shield',
    icon: [
        640,
        512,
        [],
        'f505',
        'M622.3 271.1l-115.2-45c-4.1-1.6-12.6-3.7-22.2 0l-115.2 45c-10.7 4.2-17.7 14-17.7 24.9 0 111.6 68.7 188.8 132.9 213.9 9.6 3.7 18 1.6 22.2 0C558.4 489.9 640 420.5 640 296c0-10.9-7-20.7-17.7-24.9zM496 462.4V273.3l95.5 37.3c-5.6 87.1-60.9 135.4-95.5 151.8zM224 256c70.7 0 128-57.3 128-128S294.7 0 224 0 96 57.3 96 128s57.3 128 128 128zm96 40c0-2.5.8-4.8 1.1-7.2-2.5-.1-4.9-.8-7.5-.8h-16.7c-22.2 10.2-46.9 16-72.9 16s-50.6-5.8-72.9-16h-16.7C60.2 288 0 348.2 0 422.4V464c0 26.5 21.5 48 48 48h352c6.8 0 13.3-1.5 19.2-4-54-42.9-99.2-116.7-99.2-212z'
    ]
};

export const PRESET_HIDDEN_PRODUCTS = [
    {
        id: 1,
        title: 'Gift Wrappping',
        price: 2.55,
        body_html:
            '<p>Buying&nbsp;a&nbsp;Gift?&nbsp;Let&nbsp;us&nbsp;wrap&nbsp;it&nbsp;for&nbsp;you!</p><p>One of our team, will carefully wrap all you items individually to make your (someone special)...feel special!</p>'
    },
    {
        id: 4,
        title: 'Fast Processing',
        price: 2.55,
        body_html:
            "<p>Want to get your order FAST?</p><p>Get Priority Processing and we'll bump your order up to the front of the line.&nbsp;</p>"
    },
    {
        id: 2,
        title: 'Extended waranty',
        price: 4.19,
        body_html: '<p>We will cover any manufacturing faults for 2 years!</p>'
    }
];
export const TEST_COOKIE_NAME = 'shopifyTestCookie';
export const GRANTED_STORAGE_ACCESS_COOKIE_NAME = 'shopify.granted_storage_access';

export const DEFAULT_GOAL = ({ multi_goal_type, goals }, language, currency) => {
    language = Object.keys(Languages).includes(language) ? language : 'english';
    const index = goals.length;
    const goal = multi_goal_type === 'amount' ? 40 + 20 * index : 2 + 2 * index;
    const reward = 10 + 5 * index;
    const __ = translate(language);
    return {
        // goal,
        badge: {
            show_text: true,
            text: {
                text: '{{goal}}',
                font_size: 1,
                color: default_primary
            },
            type: 2,
            image: null
        },
        specific_goals: [
            {
                currency,
                goal,
                main: true
            }
        ],
        reward_type: 'discount', // free_shipping,discount,gift
        goal_type: 'fixed',
        goal_text: {
            text: reward + '% OFF',
            font_size: 0.7,
            color: {
                r: 44,
                g: 50,
                b: 59,
                a: 1
            }
        },
        show_goal_text: true,
        confetti: false,
        confetti_length: 400,
        discount: {
            type: 'percentage',
            before: __('campaigns.add_to_unlock.discount.before'),
            after: __('campaigns.add_to_unlock.discount.after'),
            reward
        },
        free_shipping: {
            before: __('campaigns.add_to_unlock.free_shipping.before'),
            after: __('campaigns.add_to_unlock.free_shipping.after'),
            manual: true
        },
        manual: {
            before: __('campaigns.add_to_unlock.free_shipping.before'),
            after: __('campaigns.add_to_unlock.free_shipping.after')
        },
        gift: {
            before: __('campaigns.add_to_unlock.gift.before'),
            after: __('campaigns.add_to_unlock.gift.after'),
            // product: {},
            products: [],
            previous_gift: 'keep',
            multi_gift_select: 'select',
            widget: {
                active: true,
                compare_at_price_active: true,
                compare_at_price: {
                    color: { r: 141, g: 141, b: 141, a: 1 },
                    font_size: 1,
                    text: __('campaigns.add_to_unlock.gift.compare_at_price.text')
                },
                before: {
                    header: __('campaigns.add_to_unlock.gift.widget.before.header'),
                    product_name: __('campaigns.add_to_unlock.gift.widget.before.product_name'),
                    offer_highlight: {
                        color: { r: 95, g: 95, b: 95, a: 1 },
                        font_size: 1.2,
                        text: __('campaigns.add_to_unlock.gift.widget.before.offer_highlight.text')
                    },
                    // variant_selector_text: {
                    //   color: { r: 255, g: 255, b: 255, a: 1 },
                    //   font_size: 1,
                    //   text: __("campaigns.add_to_unlock.gift.widget.before.variant_selector_text.text"),
                    // },
                    background: { r: 242, g: 245, b: 255, a: 1 },
                    outline: { r: 196, g: 196, b: 196, a: 1 },
                    // variant_button_background: { r: 10, g: 133, b: 255, a: 1 },
                    multi_gift_image:
                        'https://d1s1zm0vzu692k.cloudfront.net/static/images/default_gifts.png'
                },
                selecting: {
                    header: __('campaigns.add_to_unlock.gift.widget.selecting.header'),
                    product_name: __('campaigns.add_to_unlock.gift.widget.selecting.product_name'),
                    offer_highlight: {
                        color: { r: 95, g: 95, b: 95, a: 1 },
                        font_size: 1.2,
                        text: __(
                            'campaigns.add_to_unlock.gift.widget.selecting.offer_highlight.text'
                        )
                    },
                    variant_selector_text: {
                        color: { r: 255, g: 255, b: 255, a: 1 },
                        font_size: 1,
                        text: __(
                            'campaigns.add_to_unlock.gift.widget.selecting.variant_selector_text.text'
                        )
                    },
                    background: { r: 242, g: 245, b: 255, a: 1 },
                    outline: { r: 196, g: 196, b: 196, a: 1 },
                    variant_button_background: { r: 10, g: 133, b: 255, a: 1 }
                },
                after: {
                    header: __('campaigns.add_to_unlock.gift.widget.after.header'),
                    product_name: __('campaigns.add_to_unlock.gift.widget.after.product_name'),
                    offer_highlight: {
                        color: { r: 79, g: 181, b: 110, a: 1 },
                        font_size: 1.2,
                        text: __('campaigns.add_to_unlock.gift.widget.after.offer_highlight.text')
                    },
                    background: { r: 248, g: 251, b: 246, a: 1 },
                    outline: { r: 203, g: 235, b: 206, a: 1 },
                    variant_change_text: {
                        color: { r: 134, g: 134, b: 134, a: 1 },
                        font_size: 1,
                        text: __(
                            'campaigns.add_to_unlock.gift.widget.after.variant_change_text.text'
                        )
                    }
                }
            }
            // inventory_quantity: {
            //   active: true,
            //   text: __("campaigns.add_to_unlock.gift.inventory_quantity.text")
            // }
        }
    };
};
export const COD_FORM = [];

export const STICKY_CART_OPTIONS = {
    btnStyles: [
        { value: 'square', label: 'Square' },
        { value: 'curvy', label: 'Curvy' }
        // { value: 'organic', label: 'Organic' },
    ],
    btnPosition: [
        { value: 'bottom', label: 'Bottom' },
        { value: 'top', label: 'Top' }
    ],
    visibilityOptions: [
        { value: 'always', label: 'Always' },
        { value: 'dynamic', label: 'when "Add To Cart" is hidden' }
    ],
    atcActions: [
        { value: 'checkout', label: 'Redirect to checkout page' },
        { value: 'cart', label: 'Redirect to cart' },
        { value: 'stay', label: 'Stay in product page' }
    ]
};

export const BADGES_POSITIONS = [
    { value: 'bellow_checkout', label: 'Bellow checkout button' },
    { value: 'above_checkout', label: 'Above checkout button' },
    { value: 'above_totals', label: 'Above totals' }
];

export const ANNOUNCEMENT_POSITIONS = [
    { value: 'bellow_header', label: 'Bellow cart header' },
    { value: 'bellow_products', label: 'Bellow product' },
    { value: 'above_products', label: 'Above Products' },
    { value: 'above_totals', label: 'Above Totals' }
];
